"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iPreview = exports.iPreviewStatus = exports.iConversionService = void 0;
const t = require("io-ts");
exports.iConversionService = t.keyof({
    'BimSync': null,
    'Vektorio': null,
    'Sokopro': null
});
exports.iPreviewStatus = t.union([t.literal('PROCESSING'), t.literal('PROCESSED'), t.literal('FAILED'), t.literal('NONE')]);
exports.iPreview = t.intersection([
    t.interface({
        uuid: t.string
    }),
    t.partial({
        status: exports.iPreviewStatus,
        key: t.string,
        created_at: t.number,
        conversionService: exports.iConversionService
    })
]);
//# sourceMappingURL=preview.js.map